export default {
    OrdinaryOrderMix: {
        LogiTab: {
            Parcel: 'Parcel Number',
            Company: 'Logistics Company',
            Tracking: 'Tracking Number',
            Type: 'Logistics Service Type',
            Time: 'Parcel Number Acquisition Time',
            updateTime: 'Latest Tracking Update Time',
            trackingStatus: 'Latest Tracking Status',
            Status: 'Status',
            Delivered: 'Delivered',
            InTransit: 'In Transit',
            NoRecord: 'No Tracking Updates',
            Freight: 'Freight',
        },
        EditReceiverInfo: {
            name: 'Consignee name',
            phone: 'Phone Number',
            address: 'Shipping address',
            Detailed: 'Detailed address',
            receipt: 'Modify receipt information',
            select: 'Please select a province/city/district',
            enter: 'Please enter the detailed address',
            the: 'Please enter the name of the consignee',
            mobile: "Please enter the recipient's phone number",
        },
        EditRemarks: {
            Modify: 'Modify',
            buyer: 'Please enter buyer comments',
            merchant: 'Please enter merchant comments',
            customer: 'Please enter customer service comments',
            comment: "Buyer's comment",
            Comments: 'Merchant Comments',
            service: 'Customer service comments',
        },
        GoodsInfoTab: {
            // 1
            Confirm: 'Confirm receipt',
            Pending: 'Pending',
            Unhook: 'Unhook',
            Summarize: 'Summarize By Product',
            product: 'By Product Line Details',
            suspend: 'Are you sure you want to suspend?',
            cancel: 'Are you sure you want to cancel?',
            goods: 'Are you sure to receive the goods?',
            black: 'Set black and white list',
            // 2 //3
            Receiving: 'Receiving status',
            Shipment: 'Shipment status',
            occupied: 'Pre occupied status',
            Sourcing: 'Rating Status',
            status: 'Pending status',
            Write: 'Pre emptive Write Back Status',
            update: 'Shipment update status',
            Label: 'Label',
            // name: 'Product name',
            // code: 'Commodity code',
            SKU: 'SKU',
            Giveaway: 'Giveaway or not',
            Quantity: 'Quantity',
            platform: 'Three-party platform sales unit price',
            total: 'The total price shared by the three platforms',
            sales: 'Internal sales price',
            average: 'Internal average total price',
            Cost: 'Cost unit price',
            Totalf: 'Total cost',
            Freight: 'Shipping cost',
            // 3
            Oo: 'set',
            see: 'View',
            back: 'The returned data is empty, please contact the administrator',
            Order: 'Order shipment',
            ps1: 'This order is out of stock!',
            ps2: 'This order has been approved and no need to resend!',
            ps3: "The order's pricing status is abnormal!",
        },
        LogisticsTable: {
            // 1
            outerOrderNo: 'Customer Order No',
            innerOrderNo: 'CSG Order No',
            logisticsNo: 'Job Id/Tracking No.',
            TrackingNo: 'Tracking No.',
            ParcelNo: 'Parcel No. : ',
            TrackingDetails: 'Tracking Details',
            TrackingStatus: 'Status',
            TrackingLocation: 'Location',
            TrackingTime: 'Date/Time',
            logisticsCompany: 'Courier Name',
            logisticsBusinessName: 'Courier Service Name',
            totalPrice: 'totalPrice',
            // 2
            Shipment: 'Shipping Label',
            ps1: 'Please only upload the shipping label here. (Max 5 MB)',
            ps2: 'Please use the tracking number as the file name',
            Supporting: 'Supporting Documents',
            ps3: 'Please upload additional files here such as picking slip, packing list, etc... (Max 5 MB)',
            Package: 'Package',
            PriceSearchResults: 'Rating Results',
            priceReferenceTip: 'Prices returned by the API are for reference only.',
            // 3
            Doc: 'Doc No.',
            Delivery: 'Delivery result document No./delivery notice No.',
            Logistics: 'Logistics Doc No.',
            company: 'Logistics company',
            No: 'Delivery Notice No.',
            of: 'Number of packaged items',
            time: 'Delivery time',
            Operation: 'Action',
            Details: 'Package Details',
            // 4
            creation: 'Delivery notice',
            Serial: 'Count',
            // name: 'Product name',
            // code: 'Commodity code',
            SKU: 'SKU',
            Quantity: 'Quantity',
            cancel: 'Cancel Logistics',
            send: 'BigText Push To Sap',
        },
        O2oConfirmReceipt: {
            Confirm: 'Confirm receipt',
            Upload: 'Upload voucher',
            Description: 'Description',
        },
        OrderItemTable: {
            // Product: 'Product name',
            // code: 'Product code',
            name: 'SKU Name',
            SKU: 'SKU',
            SPU: 'Batch',
            Quantity: 'Quantity',
            Whether: "Whether it's a gift or not",
            Sales: 'Sales unit price of third-party platform',
            Total: 'Total price shared by three platforms',
            price: 'Internal sales price',
            Internal: 'Internal average total price',
            unit: 'Cost unit price',
            cost: 'Total cost',
            Freight: 'Shipping cost',
            Operation: 'Action',
            Delete: 'Delete',
            returned: 'The returned data is empty, please contact the administrator',
        },
        SuspendReason: {
            Please: 'Please enter',
            Suspend: 'Suspend reason',
            continue: 'You are releasing the pending status of this order. Do you want to continue?',
        },
    }
};
